import { FC } from 'react';
import { Link } from 'react-router-dom';
import { OverlayTrigger } from 'react-bootstrap';
import { PopoverTooltipV2 as PopoverTooltip } from '@praktio/common-ui';

import { getTeamAncestorPath } from '../../../utils/functions';

interface Props {
  team: ITeam;
  teams: ITeam[];
  to: string;
  tooltipId: string;
}

const TeamBreadcrumbLink: FC<Props> = ({ team, teams, to, tooltipId }) => {
  const ancestorPath = getTeamAncestorPath(teams, team._id);
  const hasAncestors = ancestorPath.length > 1;
  const breadcrumb = ancestorPath.map((t) => t.name).join(' > ');

  const link = <Link to={to}>{team.name}</Link>;

  if (!hasAncestors) {
    return link;
  }

  return (
    <OverlayTrigger
      placement="top"
      overlay={<PopoverTooltip id={tooltipId} paragraph={breadcrumb} />}
    >
      <span>{link}</span>
    </OverlayTrigger>
  );
};

export default TeamBreadcrumbLink;
